import {useState} from "react";
import styles from 'assets/jss/ProfileStyle';
import {Button, Grid} from "@mui/material";
import {makeStyles} from '@mui/styles';
import {digitsEnToFa} from "persian-tools2";
import {Form, Formik} from "formik";
import ProfileContainer from "components/EditAgentProfile/ProfileContainer";
import validationSchema from "components/EditAgentProfile/validation";
import CustomTextField from "components/EditAgentProfile/TextField";
import SaveButtonProfile from "components/EditAgentProfile/SaveButtonProfile";
import useAgentInfo from "hooks/useAgentInfo";
import useEditAgentProfile from "hooks/useEditAgentProfile";

const useStyles = makeStyles(styles);

const EditPersonalInfo = (props) => {
    const {setActiveEdit, activeEdit} = props;
    const {data} = useAgentInfo();

    const {
        firstName,
        isScanCenter,
        phoneNumber,
        scanCenterAddress,
        lastName,
        userType,
        isMale,
        birthDate,
        yearsWithDiabet,
        insulinType,
        isUsingOralMedications,
        diabetType,
        scanCenterName,
        cityId,
    } = data || {};

    const personalList = [
        {id: 1, title: 'نام', value: `${firstName}`},
        {id: 2, title: 'نام خانوادگی', value: `${lastName}`},
        {id: 3, title: 'شماره موبایل', value: digitsEnToFa(phoneNumber)},
    ];
    const initialValues = {
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
    }
    const [saveBtn, setSaveBtn] = useState({
        loading: false,
        wait: false
    });
    const editAgentProfile = useEditAgentProfile();

    const editAgentProfileHandler = (agentPutData) => {
        editAgentProfile.mutate({agentPutData});
        saveBtnHandler()
    };
    const editClick = () => {
        setActiveEdit((prev) => ({...prev, personal: true}));
    };

    const cancelEditHandler = () => {
        setActiveEdit((prev) => ({...prev, personal: false}));
    };


    const saveBtnHandler = () => {
        setSaveBtn((prev) => ({...prev, loading: true, wait: true}));
        setTimeout(() => {
            setSaveBtn((prev) => ({...prev, loading: false}));
            setTimeout(() => {
                setSaveBtn((prev) => ({...prev, wait: false}));
                cancelEditHandler();
            }, 2000);
        }, 3100);
    };

    const handleSubmit = (values) => {
        const {
            firstName,
            lastName,
        } = values;
        console.log(values)
        const agentPutData = {
            firstName,
            lastName,
            scanCenterName,
            scanCenterAddress,
            userType,
            isScanCenter,
            isMale,
            birthDate,
            yearsWithDiabet,
            insulinType,
            isUsingOralMedications,
            diabetType,
            cityId: cityId,
        };
        editAgentProfileHandler(agentPutData)
    };


    const classes = useStyles();
    return (
        <ProfileContainer activeEdit={activeEdit} hiddenIcon={activeEdit.personal} title='اطلاعات شخصی'
                          editClick={editClick} saveBtn={saveBtn}>
            {activeEdit.personal ?
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}>
                    {(props) => (
                        <Form>
                            <Grid spacing={'14px'} container>
                                <Grid item xs={12}>
                                    <CustomTextField
                                        {...props}
                                        name='firstName'
                                        label={'نام'}
                                        type='text'
                                        maxLength={30}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomTextField
                                        {...props}
                                        name='lastName'
                                        label={'نام خانوادگی'}
                                        type='text'
                                        maxLength={30}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomTextField
                                        {...props}
                                        name='phoneNumber'
                                        label='شماره تماس'
                                        type='number'
                                        disabled
                                    />
                                </Grid>

                                <Grid className={classes.formBtnContainer} item xs={12}>
                                    <SaveButtonProfile saveBtn={saveBtn}/>
                                    <Button onClick={cancelEditHandler} className={classes.cancelBtn}>انصراف</Button>
                                </Grid>
                            </Grid>
                        </Form>
                    )}

                </Formik>
                :
                personalList.map(({id, title, value}) => (
                    <Grid
                        key={id}
                        container
                        alignItems='center'
                        justifyContent='center'
                        m='20px 0'>
                        <Grid
                            item
                            xs={6}
                            className={classes.ProfileTitle}>
                            {title}:
                        </Grid>
                        <Grid
                            item
                            xs={6}
                            className={classes.ProfileValue}>
                            {value ? digitsEnToFa(value) : '_'}
                        </Grid>
                    </Grid>
                ))}
        </ProfileContainer>
    );
};
export default EditPersonalInfo
